var map = {
	"./2fa.svg": "4123",
	"./2fa_border.svg": "c68f",
	"./bank_account_border.svg": "0a4f",
	"./bank_accounts.svg": "fc6d",
	"./bank_accounts_border.svg": "c1bf",
	"./change_password.svg": "bfbb",
	"./change_password_border.svg": "deb5",
	"./change_pin.svg": "9c8a",
	"./change_pin_border.svg": "39ef",
	"./documents.svg": "2a6d",
	"./documents_border.svg": "8758",
	"./email_notifications.svg": "39f6",
	"./email_notifications_border.svg": "56a8",
	"./face_id.svg": "28ac",
	"./face_id_border.svg": "ffbd",
	"./faqs.svg": "b9b8",
	"./faqs_border.svg": "d7b5",
	"./fiscal_information.svg": "c131",
	"./fiscal_information_border.svg": "03f4",
	"./language.svg": "5711",
	"./language_border.svg": "2760",
	"./legal_representative.svg": "b1c8",
	"./legal_representative_border.svg": "7526",
	"./logout.svg": "9115",
	"./logout_border.svg": "fa9b",
	"./organizations_details.svg": "43f9",
	"./organizations_details_border.svg": "8ac3",
	"./personal_details.svg": "dc47",
	"./personal_details_border.svg": "4557",
	"./privacy_policy.svg": "7680",
	"./privacy_policy_border.svg": "a44f",
	"./suitability.svg": "6a3c",
	"./suitability_border.svg": "1987",
	"./terms_and_conditions.svg": "5022",
	"./terms_and_conditions_border.svg": "8e7a",
	"./wallets.svg": "0766",
	"./wallets_border.svg": "b3a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10bd";